import { CurrencyDisplay, SkeletonLoader } from "../../components";
import {
  useAuth,
  useCheckoutPage,
  useMerchantApiQueryWithParams,
} from "../../hooks";
import {
  ICheckoutPricingRequest,
  ICheckoutPricingResponse,
} from "../../interfaces-and-types";

export const SaleTotal = () => {
  const { saleCurrency, saleTotal } = useCheckoutPage();
  const { api_key } = useAuth();

  // get the dynamic charges on the amount

  const {
    isSuccess,
    isError,
    // isLoading,
    data: checkoutFees,
  } = useMerchantApiQueryWithParams<
    ICheckoutPricingRequest,
    ICheckoutPricingResponse
  >(
    [
      "getCheckoutTotal",
      {
        currency: saleCurrency,
        amount: saleTotal,
      },
    ],
    {
      enabled: !!api_key && saleTotal > 0,
      retry: 2,
    }
  );

  // return isSuccess ? (
  //   <CurrencyDisplay
  //     useSymbolAsIs
  //     currencyOrSymbol={saleCurrency}
  //     amount={saleTotal}
  //   />
  return isSuccess ? (
    <CurrencyDisplay
      useSymbolAsIs
      currencyOrSymbol={saleCurrency}
      amount={checkoutFees!.charged_amount}
    />
  ) : isError ? (
    <>Fee Error</>
  ) : (
    <SkeletonLoader type="text" className="dynamic-checkout-total" />
  );
};
